import { endpointListSchema } from '../contracts/endpoints';
import { organizationIdSchema, } from '../contracts/organizations';
import { parseSchema } from '../errors';
/**
 * List the endpoints (machines) a user has reported from within an organization
 * (KIR-3035). Powers the Inventory->Users endpoints dialog.
 *
 * Authorization: Owner/Manager/Support only (contains network identifiers).
 *
 * @param client - Axios client instance
 * @param organizationId - Organization ID
 * @param userId - User ID whose endpoints to list
 * @param applyStaleFilter - KIR-3911: when true, the backend hides endpoints
 *   last seen beyond the org's inventory-visibility window (Inventory→Users
 *   dialog). Omit/false for the details popover so a specific machine still
 *   resolves even if it is stale.
 */
export async function listUserEndpoints(client, organizationId, userId, applyStaleFilter = false) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    // Note: response is already the data (not AxiosResponse) due to the
    // response interceptor in client.ts that extracts response.data
    const response = await client.get(`/organizations/${validatedId}/users/${userId}/endpoints`, applyStaleFilter ? { params: { applyStaleFilter: true } } : undefined);
    return parseSchema(endpointListSchema, response);
}
//# sourceMappingURL=endpoints.js.map